











































































import dayjs from "dayjs";
import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import AdicionarMetasLote from "./modals/AdicionarMetasLote.vue";
import Confirm from "@/shared/components/confirm.vue";
import EditarMetaVendedor from "./modals/EditarMetaVendedor.vue";
import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import {
  MetaVendedorListarDto,
  MetaVendedorService,
} from "@/services/meta-vendedor.service";

@Component({
  components: {
    AdicionarMetasLote,
    Confirm,
    EditarMetaVendedor,
    SelectYearMounth,
    Tooltip,
  },
})
export default class MetasVendedores extends mixins(GlobalMixin) {
  mesAno: string = dayjs().format("YYYY-MM");
  loading = false;
  metas: MetaVendedorListarDto[] = [];
  selectedMetas: MetaVendedorListarDto[] = [];

  headers = [
    { text: "Vendedor", value: "nomeUsuario" },
    { text: "Mês Referência", value: "mesReferencia" },
    { text: "Qtd. Pontos", value: "qtdPontos" },
    { text: "Valor Bônus", value: "valorBonus" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  get mesReferenciaApi(): string {
    return dayjs(`${this.mesAno}-01`).format("YYYY-MM");
  }

  async mounted() {
    await this.carregarMetas();
  }

  @Watch("mesAno")
  async onChangeMesAno() {
    await this.carregarMetas();
  }

  async carregarMetas() {
    this.loading = true;
    this.selectedMetas = [];

    this.metas = await MetaVendedorService.ListarMetas(
      this.mesReferenciaApi,
    ).finally(() => (this.loading = false));
  }

  async abrirModalAdicionar() {
    const modal = this.$refs.modalAdicionar as AdicionarMetasLote;
    const sucesso = await modal.abrir(this.mesReferenciaApi);

    if (sucesso) {
      await this.carregarMetas();
    }
  }

  async abrirModalEditar(meta: MetaVendedorListarDto) {
    const modal = this.$refs.modalEditar as EditarMetaVendedor;
    const sucesso = await modal.abrir(meta);

    if (sucesso) {
      await this.carregarMetas();
    }
  }

  async excluirSelecionadas() {
    if (!this.selectedMetas.length) {
      return;
    }

    const confirm = this.$refs.confirm as Confirm;
    const total = this.selectedMetas.length;
    const confirmar = await confirm.open(
      "Excluir metas",
      `Deseja realmente excluir ${total} meta(s) selecionada(s)?`,
    );

    if (!confirmar) {
      return;
    }

    this.startLoader();
    try {
      await MetaVendedorService.ExcluirMeta({
        idsMetas: this.selectedMetas.map((item) => item.idMeta),
      });

      await this.carregarMetas();
    } finally {
      this.stopLoader();
    }
  }

  async excluirItem(meta: MetaVendedorListarDto) {
    const confirm = this.$refs.confirm as Confirm;
    const confirmar = await confirm.open(
      "Excluir meta",
      `Deseja realmente excluir a meta de ${meta.nomeUsuario}?`,
    );

    if (!confirmar) {
      return;
    }

    this.startLoader();
    try {
      await MetaVendedorService.ExcluirMeta({
        idsMetas: [meta.idMeta],
      });

      await this.carregarMetas();
    } finally {
      this.stopLoader();
    }
  }

  formatCurrency(valor: number): string {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  formatMesReferencia(valor: string): string {
    if (!valor) {
      return "";
    }

    const data = dayjs(valor);
    if (data.isValid()) {
      return data.format("YYYY-MM");
    }

    if (/^\d{2}-\d{4}$/.test(valor)) {
      return valor.replace("-", "/");
    }

    return valor;
  }
}
